// Counts each [data-count-to] number up from 0 once, when the strip is 30% visible:
// 1800ms with ease-out cubic, 1 - (1 - t)^3. With reduced motion the final values stay as rendered.
(function () {
  'use strict';

  var DURATION = 1800;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var format = new Intl.NumberFormat('es-MX');

  function render(el, value) {
    el.textContent = (el.dataset.prefix || '') + format.format(value);
  }

  function animate(el) {
    var target = Number(el.dataset.countTo);
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / DURATION, 1);
      render(el, Math.round(target * (1 - Math.pow(1 - t, 3))));
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  document.querySelectorAll('[data-stats]').forEach(function (strip) {
    var numbers = strip.querySelectorAll('[data-count-to]');
    if (!numbers.length || reduce || !('IntersectionObserver' in window)) return;
    numbers.forEach(function (el) { render(el, 0); });
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();
      numbers.forEach(animate);
    }, { threshold: 0.3 });
    observer.observe(strip);
  });
})();
